"use client";
import React from "react";
import styles from "./CompareNowCard.module.scss";
import Image from "next/image";
import Text from "@components/atoms/Text";
import assetLoader from "@utils/internalImageLoder";
import Button from "@components/atoms/Button";
import { CompareNowCardProps } from "./CompareNowCard.types";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";
import { useAppDispatch } from "@lib/redux/hooks";
import { setCopilotCarData } from "@lib/redux/slices/carDataSlice";

export default function CompareNowCard({
  heading,
  subheading,
  buttonText,
  chatBotPrompt,
  mmvMobileText,
  mmvMobileButtonText,
  isMMV,
  makeName,
  modelName,
  variantName,
  cityName,
  pageType,
  carAvailability,
}: CompareNowCardProps) {
  
  const dispatch = useAppDispatch();
  
  const handleButtonClick = async () => {
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: pageType,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_chat_bot",
        cta_name: "Comparison",
        section: "Comparison",
        car_availability: carAvailability,
        prompt: chatBotPrompt || "",
        city_name: cityName,
        vehicle_make: makeName,
        vehicle_model: modelName,
        ...(variantName && { vehicle_variant: variantName }),
      },
    });

    dispatch(setCopilotCarData({
      make: makeName || "",
      model: modelName || "",
      variant: variantName || "",
    }));

    (window as any).copilot.open();
    (window as any).copilot.sendMessage(chatBotPrompt);
  };

  return (
    <>
      <div className={`${styles.section} ${isMMV ? styles.mmvSection : ""}`}>
        <div className={`${styles.logoContainer}`}>
          <Image
            src={`${assetLoader()}/icons/compare-now.svg`}
            alt="Budget match logo"
            width={80}
            height={80}
            className={styles.logo}
            loading="lazy"
          />
        </div>
        <div className={`${styles.contentContainer}`}>
          <div className={styles.textContainer}>
            <Text level="p" className={styles.heading}>
              {heading}
            </Text>
            <Text level="p" className={styles.subheading}>
              {subheading}
            </Text>
          </div>
          <div className={styles.buttonContainer}>
            <Button className={styles.button} onClick={handleButtonClick}>
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
      {isMMV && (
        <div className={styles.mmvContainer}>
          <Text level="h2" className={styles.mmvMobileText}>
            {mmvMobileText}
          </Text>
          <Button
            className={styles.mmvMobileButton}
            onClick={handleButtonClick}
          >
            {mmvMobileButtonText}
          </Button>
        </div>
      )}
    </>
  );
}
